var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4acf5eb38ce555396893a41b7d4fd4146886b352"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["aspen@rove-xf"]={id:"4acf5eb38ce555396893a41b7d4fd4146886b352"};
      